module.exports = __webpack_public_path__ + "img/logo-d.3a9be5b7.png";